import { FaWhatsapp } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { SITE } from "@/lib/site";

export default function WhatsAppFloat() {
  const [expanded, setExpanded] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 2200);
    const t2 = setTimeout(() => setExpanded(true), 3800);
    const t3 = setTimeout(() => setExpanded(false), 8500);
    return () => {
      clearTimeout(t);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, []);

  const href = `https://wa.me/${SITE.whatsapp.number}?text=${encodeURIComponent(
    SITE.whatsapp.message
  )}`;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, scale: 0.6, y: 40 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.6 }}
          transition={{ type: "spring", damping: 15, stiffness: 200 }}
          className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-50 flex items-center gap-3"
          onMouseEnter={() => setExpanded(true)}
          onMouseLeave={() => setExpanded(false)}
        >
          <AnimatePresence>
            {expanded && (
              <motion.a
                href={href}
                target="_blank"
                rel="noreferrer"
                data-testid="whatsapp-float-badge"
                initial={{ opacity: 0, x: 20, scale: 0.85 }}
                animate={{ opacity: 1, x: 0, scale: 1 }}
                exit={{ opacity: 0, x: 20, scale: 0.85 }}
                transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                className="hidden sm:flex items-center gap-2 pl-4 pr-5 py-3 rounded-full bg-white/95 backdrop-blur border border-black/10 text-[#0B0B14] text-sm font-semibold shadow-xl"
              >
                <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
                <span>Cotizar mayorista</span>
              </motion.a>
            )}
          </AnimatePresence>

          <a
            href={href}
            target="_blank"
            rel="noreferrer"
            aria-label="Contactar por WhatsApp"
            data-testid="whatsapp-float-button"
            className="relative wa-pulse group"
          >
            <motion.span
              animate={{ scale: [1, 1.06, 1] }}
              transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
              className="relative z-10 flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-emerald-500 text-white shadow-[0_12px_40px_-8px_rgba(16,185,129,0.55)] group-hover:bg-emerald-600 transition-colors"
            >
              <FaWhatsapp className="w-7 h-7 md:w-8 md:h-8" />
            </motion.span>
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
